/**
 * Включен impersonate
 *
 * @return {boolean}
 */
export function isImpersonating() {
  return Boolean(localStorage.getItem('prevUserToken'))
}
